import React, { useContext, useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import styles from "../../../Styles/ComponentStyles/MainPages/dashboard.module.scss";
import globalStyles from "../../../Styles/global.module.scss";
import AppNavbar from "../../../Components/AppNavbar/AppNavbar";
import DashboardNavbar from "../DashboardNavbar/DashboardNavbar";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  IconButton,
  MenuItem,
  Menu,
  Typography,
  Tooltip,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  DeleteOutlineOutlined as DeleteOutlineOutlinedIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { pdfData, useIsBelow1200, useIsBelow600 } from "../../../Utils/Constant/Constant";
import PdfCards from "../../../Components/PdfCards/PdfCards";
import { useNavigate } from "react-router-dom";
import NewResourceDialog from "../../../Components/Dialogs/NewResourceDialog";
import GlobalTextfield from "../../../Utils/Layout/GlobalTextfield/GlobalTextfield";
import GlobalWarningDialog from "../../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog";
import GlobalDialog from "../../../Utils/Layout/GlobalDialog/GlobalDialog";
import GlobalButton from "../../../Utils/Layout/GlobalButton/GlobalButton";
import dashboardStyles from "../../../Styles/ComponentStyles/MainPages/dashboard.module.scss";
import { DashboardContext, DashboardDetailPayload } from "../../../Context/DashboardDetailContext";
import { MarketAndSalesResourcePayloadDataModel, MarketAndSalesResourcesResponseModel, ResourceData, updateResourceInterface } from "../../../models/dashboardAxiosModels";
import MarketAndSalesResourceDialog from "../../../Components/Dialogs/MarketAndSalesResourceDialog";
import { useSnackbar } from "../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar";
import { GlobalUserContext, GlobalUserContextPayload } from "../../../Context/GlobalUserDetailContext";
import agent from "../../../Services/api";
import Plan401kChildren from "../DashboardNavbar/DashboardNavbarChildren/Plan401kChildren";

interface PdfData {
  img: string;
  pdfHeadName: string;
  pdfSubHeadName: string;
}

const DashboardMarketingAndSalesResources = () => {

  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const {
    setFlagLoader,
    userProfileDetails
  } = useContext(GlobalUserContext) as GlobalUserContextPayload

  const {
    marketAndSalesResourceDetails,
    setMarketAndSalesResourceDetails,
    getMarketAndSalesDetails,

    marketingAndSalesResorcePayloadDetails,
    setMarketingAndSalesResorcePayloadDetails,

  } = useContext(DashboardContext) as DashboardDetailPayload

  const isProfileAdmin = userProfileDetails?.user?.flagAdmin
  const isBelow1200 = useIsBelow1200()

  const [expanded, setExpanded] = useState<number | null>(null);
  const [editCategoryNameId, setEditCategoryNameId] = useState<number | null>(null);
  const [flagEditResource, setFlagEditResource] = useState<boolean>(false)

  const [categoryName, setCategoryName] = useState<string | "">("");
  const [previousCategoryName, setPreviousCategoryName] = useState<string | "">("");
  const [marketAndSalesPdfId, setMarketAndSalesPdfId] = useState<number | null>(null)
  const [flagDeleteResourceDialog, setFlagDeleteResourceDialog] = useState<boolean>(false);
  const [flagNewResourceDialog, setFlagNewResourceDialog] = useState<boolean>(false);
  const [flagOpenPdfDialog, setFlagOpenPdfDialog] = useState<boolean>(false);
  const [currentPdfUrl, setCurrentPdfUrl] = useState<string | "">("");
  const [storedDeleteId, setStoredDeleteId] = useState<any>({
    category_name: "",
    category_id: null,
    marketandsales_pdf_new_id: null,
  })

  const isBelow600 = useIsBelow600()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);


  // Menu functions
  const handleMenuClick = (e: React.MouseEvent<HTMLElement>, category_id: number | null, category_name: string) => {
    setAnchorEl(e.currentTarget);
    setEditCategoryNameId(category_id);
    setCategoryName(category_name);
    setPreviousCategoryName(category_name);
    setStoredDeleteId({
      category_name,
      category_id,
      marketandsales_pdf_new_id: null
    });
    setMarketingAndSalesResorcePayloadDetails(prev => prev ? { ...prev, categoryID: category_id } : null);
  };

  const handleMenuAddResource = (e: React.MouseEvent<HTMLElement>, category_id: number | null, category_name: string) => {
    handleMenuClose(e);
    setFlagNewResourceDialog(true);
    setMarketAndSalesPdfId(null);
    setCategoryName(category_name)
    setMarketingAndSalesResorcePayloadDetails((prev: MarketAndSalesResourcePayloadDataModel | null) => {
      return prev ? { ...prev, categoryID: category_id } : null
    })
  };

  const handleMenuEditResource = (e: React.MouseEvent<HTMLElement>, category_id: number | null, category_name: string) => {
    handleMenuClose(e);
    setFlagEditResource(true)
    setEditCategoryNameId(category_id);
    setCategoryName(category_name);
    setPreviousCategoryName(category_name)
  };

  const handleMenuDeleteResource = (e: React.MouseEvent<HTMLElement>, category_id: number | null, category_name: string) => {
    handleMenuClose(e);
    setFlagDeleteResourceDialog(true)
    setStoredDeleteId({
      category_name: category_name,
      category_id: category_id,
      marketandsales_pdf_new_id: null
    })
  }

  const handleMenuClose = (e: React.MouseEvent<HTMLElement>) => {
    handleButtonClick(e);
    setAnchorEl(null);
  };

  const handleChange = (panel: number | null) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : null);
  };

  const handleClick = () => {
    navigate("/");
  };

  const handleButtonClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await getMarketAndSalesDetails();
      console.log("response of getMarketAndSalesDetails", response);
      setFlagLoader(true)
      if (response?.status) {
        if (response?.data && Array.isArray(response.data)) {
          setMarketAndSalesResourceDetails(response.data);
        }
        setFlagLoader(false)
      }
      else {
        const error = response?.data?.error?.message || "Something Went Wrong!"
        setMarketAndSalesResourceDetails([]);
        showSnackbar(error, "error")
        setFlagLoader(false)
      }
    };
    fetchData();
  }, []);

  const handleEditResourceChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, resource: MarketAndSalesResourcesResponseModel) => {
    const value = e.target.value;
    // console.log(value)
    // Regular expression to check for special characters (only allow alphanumeric and spaces)
    const specialCharRegex = /[^a-zA-Z0-9 ]/;

    if (specialCharRegex.test(value)) {
      // If special characters are found, show the snackbar
      showSnackbar('Special characters are not allowed. Please enter valid category name', 'error');
    } else {
      // If no special characters, update the state
      setCategoryName(value);
      setMarketingAndSalesResorcePayloadDetails((prev: MarketAndSalesResourcePayloadDataModel | null) => {
        return prev ? { ...prev, categoryID: resource.category_id, categoryName: value } : null;
      });
    }
  };

  const handleEditResource = async () => {

    setFlagEditResource(false)
    if (categoryName == "" || categoryName == null) {
      return;
    }
    if (categoryName === previousCategoryName) {
      showSnackbar("No changes made. Category Name same as previous", "error");
      setEditCategoryNameId(null)
      return;
    }

    const payload: updateResourceInterface = {
      categoryName: marketingAndSalesResorcePayloadDetails?.categoryName ?? "",
      categoryID: marketingAndSalesResorcePayloadDetails?.categoryID ?? null,
      marketandsales_pdf_new_id: null,
      resource:
      {
        description: null,
        hyperlink: null,
        hyperlink_name: null,
        google_storage_file_id: null,
        google_storage_thumbnail_id: null
      }
    }

    setFlagLoader(true)
    const response = await agent.marketAndSalesResourceUpdateAPI.put(payload)
    if (response?.status && response?.data) {
      const response = await getMarketAndSalesDetails()
      showSnackbar("Resource updated successfully!", "success")
      if (response?.status) {
        if (response?.data && Array.isArray(response.data)) {
          setMarketAndSalesResourceDetails(response.data);
        }
        setFlagLoader(false)
      }
      else {
        const error = response?.data?.error?.message || "Something Went Wrong!"
        setMarketAndSalesResourceDetails([]);
        showSnackbar(error, "error")
        setFlagLoader(false)
      }
    } else {
      const error = response?.data?.error?.message || "Something Went Wrong!"
      showSnackbar(error, "error")
      setFlagLoader(false)
    }
    setEditCategoryNameId(null)
    setMarketingAndSalesResorcePayloadDetails((prev: MarketAndSalesResourcePayloadDataModel | null) => {
      return prev ? { ...prev, categoryName: "" } : null
    })
  }

  const handleDeleteResource = async () => {
    const payload: any = {
      marketandsales_pdf_new_id: storedDeleteId?.marketandsales_pdf_new_id,
      category_id: storedDeleteId?.category_id
    }
    setFlagLoader(true)
    const deleteResponse = await agent.deleteMarketAndSalesSubject.delete(payload)
    if (deleteResponse.status) {
      showSnackbar("Resource deleted successfully!", "success")
      const response = await getMarketAndSalesDetails();
      if (response?.status) {
        if (response?.data && Array.isArray(response.data)) {
          setMarketAndSalesResourceDetails(response.data);
          setFlagDeleteResourceDialog(false)
        }
        setFlagLoader(false)
      }
      else {
        const error = response?.data?.error?.message || "Something Went Wrong!"
        setMarketAndSalesResourceDetails([]);
        showSnackbar(error, "error")
        setFlagLoader(false)
        setFlagDeleteResourceDialog(false)
      }
    }
  }

  const handleEditPdfDialog = (pdfMainHeading: string, data: ResourceData, resource: MarketAndSalesResourcesResponseModel) => {
    setFlagNewResourceDialog(true);
    setCategoryName(pdfMainHeading);
    setMarketAndSalesPdfId(data?.marketandsales_pdf_new_id);
    setMarketingAndSalesResorcePayloadDetails({
      categoryName: resource?.category_name,
      categoryID: null,
      description: data?.pdf_description,
      hyperlink: data?.hyperlink ? data?.hyperlink : null,
      hyperlink_name: data?.hyperlink_name ? data?.hyperlink_name : null,
      google_storage_file_id: data?.google_storage_file_id || null,
      google_storage_thumbnail_id: data?.google_storage_thumbnail_id || null,
      file: data?.file || null,
      thumbnail: data?.thumbnail || null
    });
  };

  const handleDeletePdfDialog = (pdfMainHeading: string, data: ResourceData) => {
    setFlagDeleteResourceDialog(true);
    setStoredDeleteId({
      category_name: pdfMainHeading,
      category_id: null,
      marketandsales_pdf_new_id: data?.marketandsales_pdf_new_id
    });
  };

  const handleOpenPdfDialog = (pdfUrl: string) => {
    setCurrentPdfUrl(pdfUrl);
    setFlagOpenPdfDialog(true);
  };


  const handleNewResourceDialogClose = () => {
    setFlagNewResourceDialog(false)
    setMarketingAndSalesResorcePayloadDetails({
      categoryName: "",
      categoryID: null,
      description: "",
      hyperlink: null,
      hyperlink_name: null,
      google_storage_file_id: null,
      google_storage_thumbnail_id: null,
      file: null,
      thumbnail: null
    })
  }

  return (
    <>
      {!isBelow1200 &&
        <AppNavbar />
      }

      <DashboardNavbar
        onClick={handleClick}
        headName={"Marketing And Sales Resources"}
        children={
          <Grid>
            {isProfileAdmin &&
              <GlobalButton
                value="New Resource"
                className={`${globalStyles.globleButtonStyleV2}`}
                startIcon={<AddIcon />}
                onClick={() => {
                  setCategoryName("Add New Resource")
                  setFlagNewResourceDialog(true);
                  setMarketAndSalesPdfId(null)
                }}
              />
            }
          </Grid>
        }
      />

      <GlobalDialog
        flagHeadSection={true}
        maxWidth="sm"
        dialogHead={"Delete Confirmation"}
        open={flagDeleteResourceDialog}
        view={
          <GlobalWarningDialog
            popupDescription={`Are you sure you want delete ${storedDeleteId?.category_id ? `category ${storedDeleteId?.category_name}` : `resource ${storedDeleteId?.category_name}`}?`}
            primaryButtonText={"Delete"}
            secondaryButtonText={"Cancel"}
            primaryButtonWidth="175px"
            secondaryButtonWidth="175px"
            onDelete={handleDeleteResource}
            handleClose={() => {
              setFlagDeleteResourceDialog(false);
            }}
          />
        }
        onClose={() => {
          setFlagDeleteResourceDialog(false);
        }}
      />

      <GlobalDialog
        flagHeadSection={true}
        maxWidth="md"
        dialogHead={categoryName}
        open={flagNewResourceDialog}
        view={
          <MarketAndSalesResourceDialog
            flag={categoryName}
            flagNewResourceDialog={flagNewResourceDialog}
            setFlagNewResourceDialog={setFlagNewResourceDialog}
            onClose={handleNewResourceDialogClose}
            marketAndSalesPdfId={marketAndSalesPdfId}
          />
        }
        onClose={handleNewResourceDialogClose}
      />

      <GlobalDialog
        flagHeadSection={true}
        maxWidth="xl"
        dialogHead="View PDF"
        open={flagOpenPdfDialog}
        view={
          <iframe
            src={`${currentPdfUrl}#toolbar=0`}
            width="100%"
            height="800px"
          />
        }
        onClose={() => setFlagOpenPdfDialog(false)}
      />

      <Grid container className={`${styles.dsMarketingContainer}`}>
        <Grid size={{ xs: 12 }} className={`${styles.dsMarketing}`}>
          <Grid container>
            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12 }}>
              {marketAndSalesResourceDetails && marketAndSalesResourceDetails?.map((resource: MarketAndSalesResourcesResponseModel) => {
                return (
                  <Accordion
                    key={resource.category_id}
                    expanded={expanded == resource.category_id}
                    onChange={handleChange(resource.category_id)}
                    className={`${styles.dsGlobalFeatureCardStyle}`}
                    sx={{ padding: "0px !important" }}
                  // onBlur={() => { if (editCategoryNameId === resource.category_id) setEditCategoryNameId(null) }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#ffffff" }} />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Grid container sx={{ width: "100%", alignItems: "center", justifyContent: "space-between" }} >
                        <Grid sx={{ width: isBelow600 ? "80%" : "60%" }} >
                          {(isBelow600 ? (editCategoryNameId === resource.category_id && flagEditResource) : (editCategoryNameId === resource.category_id)) ? (
                            <div onClick={handleButtonClick}>
                              <GlobalTextfield
                                value={categoryName}
                                onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => handleEditResourceChange(e, resource)}
                                fullWidth
                                size="medium"
                                autoComplete="off"
                                onKeyDown={(e: any) => {
                                  if (e.key === 'Enter') {
                                    handleEditResource();
                                  }
                                }
                                }
                                onBlur={(e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => { handleEditResource() }}
                              /></div>
                          ) : (
                            <Typography className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV16}`}>
                              {resource.category_name}
                            </Typography>
                          )}
                        </Grid>

                        {/* --Operation buttons-- */}
                        <Grid>
                          <Grid container sx={{ columnGap: "14px", paddingRight: "14px" }} >
                            {isProfileAdmin &&
                              <>
                                {isBelow600 ?
                                  <Grid size={{ xs: 1 }}>
                                    <IconButton sx={{ padding: "0px", alignItems: "flex-start" }}
                                      onClick={(e) => {
                                        handleMenuClick(e, resource?.category_id, resource?.category_name)
                                      }}>
                                      <MoreVertIcon sx={{ fontSize: "18px", color: "white" }} />
                                    </IconButton>
                                    <Menu
                                      MenuListProps={{
                                        'aria-labelledby': 'long-button',
                                      }}
                                      anchorEl={anchorEl}
                                      open={open}
                                      onClose={handleMenuClose}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                      }}
                                      sx={{
                                        '& .MuiPaper-root': {
                                          boxShadow: 'none',
                                        },
                                      }}
                                    >
                                      <MenuItem
                                        onClick={(e) => {
                                          handleMenuAddResource(e, resource?.category_id, resource?.category_name)
                                        }} >
                                        Add New</MenuItem>
                                      <MenuItem
                                        onClick={(e) => {
                                          handleMenuEditResource(e, resource?.category_id, resource?.category_name)
                                        }} >
                                        Edit</MenuItem>
                                      <MenuItem
                                        onClick={(e) => {
                                          handleMenuDeleteResource(e, resource?.category_id, resource?.category_name)
                                        }} >
                                        Delete</MenuItem>
                                    </Menu>
                                  </Grid>
                                  :
                                  <>
                                    {editCategoryNameId !== resource.category_id &&
                                      <>
                                        <Grid>
                                          <IconButton
                                            sx={{
                                              borderRadius: "6px",
                                              boxShadow: "0px 0px 2px 0px #FFFFFF80",
                                            }}
                                            onClick={(e) => {
                                              handleMenuAddResource(e, resource?.category_id, resource?.category_name)
                                            }}
                                          >
                                            <Tooltip
                                              title="Add Resource"
                                              arrow
                                              placement="bottom"
                                              componentsProps={{
                                                tooltip: { className: globalStyles.globalTooltipStyle },
                                                arrow: { className: globalStyles.globalTooltipArrowStyle },
                                              }}
                                            >
                                              <AddIcon className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV20}`} />
                                            </Tooltip>
                                          </IconButton>
                                        </Grid>
                                        <Grid>
                                          <IconButton
                                            sx={{
                                              borderRadius: "6px",
                                              boxShadow: "0px 0px 2px 0px #FFFFFF80",
                                            }}
                                            onClick={(e) => {
                                              handleMenuEditResource(e, resource?.category_id, resource?.category_name)
                                            }}
                                          >
                                            <Tooltip
                                              title="Edit Resource Section Name"
                                              arrow
                                              placement="bottom"
                                              componentsProps={{
                                                tooltip: { className: globalStyles.globalTooltipStyle },
                                                arrow: { className: globalStyles.globalTooltipArrowStyle },
                                              }}
                                            >
                                              <EditIcon className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV20}`} />
                                            </Tooltip>
                                          </IconButton>
                                        </Grid>
                                        <Grid>
                                          <IconButton
                                            sx={{
                                              borderRadius: "6px",
                                              boxShadow: "0px 0px 2px 0px #FFFFFF80",
                                            }}
                                            onClick={(e) => {
                                              handleMenuDeleteResource(e, resource?.category_id, resource?.category_name)
                                            }}
                                          >
                                            <Tooltip
                                              title="Delete Resource Section"
                                              arrow
                                              placement="bottom"
                                              componentsProps={{
                                                tooltip: { className: globalStyles.globalTooltipStyle },
                                                arrow: { className: globalStyles.globalTooltipArrowStyle },
                                              }}
                                            >
                                              <DeleteOutlineOutlinedIcon className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV20}`} />
                                            </Tooltip>
                                          </IconButton>
                                        </Grid>
                                      </>
                                    }
                                  </>
                                }
                              </>}
                          </Grid>
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid size={{ xs: 12 }}>
                        <Grid container sx={{ gap: "20px" }}>
                          {resource && resource?.resources?.length > 0 && resource?.resources?.map((data) => {
                            const pdfMainHeading = (data?.file?.google_storage_original_file_name) ? (data?.file?.google_storage_original_file_name) : (data.hyperlink_name)
                            const pdfDiscription = data?.pdf_description
                            const pdfUrl = (data?.file?.google_storage_public_url) ? (data?.file?.google_storage_public_url) : data?.hyperlink
                            return (
                              <>
                                <Grid className={`${styles.pdfCarditem}`}>
                                  <PdfCards
                                    pdfMainName={pdfMainHeading}
                                    pdfSubName={pdfDiscription}
                                    pdfUrl={pdfUrl}
                                    data={data}
                                    flagOpenEditPdfDialog={() => handleEditPdfDialog(pdfMainHeading, data, resource)}
                                    flagOpenDeletePdfDialog={() => handleDeletePdfDialog(pdfMainHeading, data)}
                                    flagOpenPdfDialog={() => handleOpenPdfDialog(pdfUrl)}
                                  />
                                </Grid>
                              </>
                            );
                          })}
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default DashboardMarketingAndSalesResources;
